module.exports = __webpack_public_path__ + "img/virusColectivo4.2272d5c4.jpg";